// extracted by mini-css-extract-plugin
module.exports = {"ConnectButton":"Modal_ConnectButton__2iPme","ConnectButtonSmall":"Modal_ConnectButtonSmall__152hc"};